<template>
  <div class="col ">
    <template>
      <div class="q-pa-md row items-start q-gutter-md">
        <q-card
          flat
          class="my-card q-ml-sm"
        >
          <q-card-section class="card-info q-pa-sm q-mb-xs">
            <q-item class="q-pa-none">
              <q-item-section>
                <q-item-label class="row items-center q-pa-none">
                  <div class="col-auto q-mr-md">
                    <q-icon
                      size="lg"
                      name="mdi-account"
                    />
                  </div>

                  <div class="col card-title ">
                    {{ contacts.name.formatted_name }}
                    <q-tooltip>{{ contacts.name.formatted_name }}</q-tooltip>
                  </div>
                </q-item-label>
                <q-item-label caption>
                  <div
                    class="row justify-between items-center q-pr-md q-mt-sm q-ml-xs"
                    v-for="(phone, index) in phones"
                    :key="index"
                  >
                    <div class="col">
                      {{ phone.number }}
                    </div>

                    <ListBrokers
                      size="18px"
                      @on-template-select="(template) => handleStartChat(template, phone.number)"
                    />

                    <q-btn
                      dense
                      size="xs"
                      unelevated
                      padding="0"
                      class="col-auto q-pa-xs"
                      @click="handleStartCall(phone.number)"
                    >
                      <PhoneDialIcon />
                      <q-tooltip>Discar para esse número</q-tooltip>
                    </q-btn>
                  </div>
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-card-section>
        </q-card>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ListBrokers from '@/components/ListBrokers'
import PhoneDialIcon from '@/assets/icons/phoneDial.svg'
import { startChat, getFormatedNumber } from '@/libs/startAttendance'

export default {
  components: {
    ListBrokers,
    PhoneDialIcon
  },

  props: {
    contacts: {}
  },

  computed: {
    ...mapState({
      isPaused: ({ agentModule }) => Boolean(agentModule?.session?.agent?.paused),
      isNotConnected: ({ sipModule }) => !sipModule.sipConnected
    }),

    phones () {
      return this.contacts.phones.map((phone) => ({ number: phone.wa_id ?? phone.phone }))
    }
  },

  methods: {
    ...mapActions({
      call: 'sipModule/call'
    }),

    async handleStartCall  (contactPhone) {
      if (this.isNotConnected) return
      const areaCode = this.$store.state.agentModule?.provision?.areaCode || ''

      const phone = sanitize(contactPhone)
      const nationalNumber = phone.startsWith('55') || phone.length <= 11
      const contact = nationalNumber ? correctNumber(phone) : `00${phone}`
      const { contact: contactDestinantion } = await getFormatedNumber({ contact }, areaCode)

      return this.call(contactDestinantion)
    },

    handleStartChat (template, phoneNumber) {
      const vm = this
      const templateId = template.id
      const phone = sanitize(phoneNumber)
      const contactDestinantion = phone.startsWith('55') ? phone : `+${phone}`
      startChat(vm, contactDestinantion, templateId, template)
    }
  }
}

const sanitize = (phone) => (
  phone.split(/\D+/).join('')
)

const correctNumber = (number) => {
  if (number.startsWith('55')) number = number.substr(2)

  const isMobile = ['8', '9'].includes(number[2])
  const ddd = number.slice(0, 2)
  if (number.length < 11 && isMobile) number = `${ddd}9${number.substr(2)}`

  return number
}
</script>

<style lang="sass" scoped>
.my-card
  width: 250px
  border-radius: 7px
  border: 1px solid #ddd
  background-color: #d9fdd3

.card-info
  height: auto
.card-title
  font-size: 14px
  font-weight: 600
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
</style>
